import { render } from "./DynamicFormPluginProp.vue?vue&type=template&id=129efea3&scoped=true&ts=true"
import script from "./DynamicFormPluginProp.vue?vue&type=script&lang=ts"
export * from "./DynamicFormPluginProp.vue?vue&type=script&lang=ts"

import "./DynamicFormPluginProp.vue?vue&type=style&index=0&id=129efea3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-129efea3"]])

export default __exports__